import styled, { css } from "styled-components";
import { FC, MouseEventHandler } from "react";

import { BaseWheel, ProgressWheel } from "./Wheels";

type StyledSvgProps = {
  $height: number;
};

const StyledSvg = styled.svg<StyledSvgProps>`
  ${({ $height }) => css`
    height: ${$height}px;
    width: ${$height}px;
  `}
  circle {
    cursor: pointer;
  }
`;

export enum GraphTestIds {
  BaseWheel = "base-wheel",
  ProgressWheel = "progress-wheel",
}

const VIEWBOX_SIZE = 20;
const WHEEL_STROKE_WIDTH = 1.2;
const WHEEL_RADIUS = (VIEWBOX_SIZE - WHEEL_STROKE_WIDTH) / 2;

type GraphProps = {
  percent: number; // between 0 and 100
  height: number;
  onHoverBaseWheel?: MouseEventHandler;
  onHoverProgressWheel?: MouseEventHandler;
  showProgress?: boolean;
};

export const Graph: FC<GraphProps> = ({
  percent,
  height,
  onHoverBaseWheel,
  onHoverProgressWheel,
  showProgress,
}) => (
  <StyledSvg $height={height} viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}>
    <BaseWheel
      testId={GraphTestIds.BaseWheel}
      onMouseOver={onHoverBaseWheel}
      radius={WHEEL_RADIUS}
      wheelStrokeWidth={WHEEL_STROKE_WIDTH}
    />
    {showProgress && (
      <ProgressWheel
        testId={GraphTestIds.ProgressWheel}
        onMouseOver={onHoverProgressWheel}
        radius={WHEEL_RADIUS}
        percent={percent}
        viewBoxSize={VIEWBOX_SIZE}
        wheelStrokeWidth={WHEEL_STROKE_WIDTH}
      />
    )}
  </StyledSvg>
);
